<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div :class="isGenerating">
          <p
            class="mt-0 mb-3 text-md white bold"
          >Só um momento, atualizando seu plano de nutrição da semana</p>
          <p class="mt-0 mb-0 text-sm white">
            <ion-icon mode="ios" name="flower" size="large" class="loading-icon"></ion-icon>
          </p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title white">Editar objetivo</p>
        <div class="edit-block-fixed mt-5">
          <label class="white bold">Qual o seu objetivo principal com a dieta?</label>
          <div class="mb-2 mt-4" @click="selectGoal('loseWeight')">
            <div :class="loseWeight.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Emagrecimento</p>
              <p class="mt-0 mb-0 text-left text-sm thin">
                Dieta
                <span class="bold green">Low Carb</span> para perda de gordura
              </p>
            </div>
          </div>
          <div class="mb-2" @click="selectGoal('gainMuscles')">
            <div :class="gainMuscles.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Hipertrofia</p>
              <p class="mt-0 mb-0 text-left text-sm thin">Dieta para ganho de massa muscular</p>
            </div>
          </div>
          <div class="mb-5 pb-3" @click="selectGoal('stayHealthy')">
            <div :class="stayHealthy.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Equilíbrio</p>
              <p class="mt-0 mb-0 text-left text-sm thin">Dieta balanceada para manter-se bem</p>
            </div>
          </div>
          <ion-button
            shape="round"
            expand="block"
            mode="ios"
            class="bottom-button"
            @click="saveGoal"
          >
            <ion-icon mode="ios" name="arrow-forward" class="white"></ion-icon>
          </ion-button>
          <p
            class="disclaimer text-sm white ion-text-center"
          >Sua dieta e lista de compras serão recalculados.</p>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// moment
import moment from "moment";
moment.locale("pt-br");
// store
import store from "../../utils/store.js";
// utils
import { calculateTargets } from "@/utils/formulas.js";
import generateWeeklyMealplan from "../../utils/mealplan.js";
// component
export default {
  name: "EditGoal",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      isGenerating: "d-none",
      goal: null,
      loseWeight: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      },
      gainMuscles: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      },
      stayHealthy: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.push({
        name: "Goal"
      });
    },
    selectGoal(goal) {
      this.goal = goal;
      this.nextButtonColor = "primary";
      if (goal === "loseWeight") {
        this.loseWeight = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
      } else if (goal === "gainMuscles") {
        this.loseWeight = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
      } else {
        this.loseWeight = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
      }
    },
    async saveGoal() {
      const instance = this;
      instance.startLoading();
      instance.isGenerating = "generating-banner-full";
      const goal = instance.goal;
      if (goal) {
        await db
          .collection("users")
          .doc(instance.profile.id)
          .update({
            goal: goal
          });
        instance.profile.data.goal = goal;
        store.updateProfile(instance.profile);
        const params = {
          goal: instance.profile.data.goal,
          gender: instance.profile.data.gender,
          age: instance.profile.data.age,
          height: instance.profile.data.height,
          weight: instance.profile.data.weight,
          bf: instance.profile.data.bf,
          sportsFrequency: instance.profile.data.sportsFrequency,
          sportsTime: instance.profile.data.sportsTime
        };
        const target = calculateTargets(params);
        db.collection("users")
          .doc(instance.profile.id)
          .update({
            target: target
          });
        instance.profile.data.target = target;
        const today = moment();
        for (let i = 0; i < 8; i++) {
          const date = moment(today)
            .add(i, "days")
            .format("DD/MM/YYYY");
          const weekStart = moment(today)
            .startOf("week")
            .format("DD/MM/YYYY");
          const mpRef = db
            .collection("mealplans")
            .where("userId", "==", instance.user.uid)
            .where("day", "==", date);
          const snapshot = await mpRef.get();
          if (!snapshot.empty) {
            let ids = [];
            snapshot.forEach(doc => {
              ids.push(doc.id);
            });
            for (let j = 0; j < ids.length; j++) {
              await db
                .collection("mealplans")
                .doc(ids[j])
                .delete();
            }
            const slRef = db
              .collection("shoppingLists")
              .where("startDay", "==", weekStart);
            const snap = await slRef.get();
            let slId;
            snap.forEach(doc => {
              slId = doc.id;
            });
            if (slId) {
              await db
                .collection("shoppingLists")
                .doc(slId)
                .delete();
            }
          }
        }
        store.state.mealplans = [];
        await generateWeeklyMealplan(instance.user.uid);
        store.updateProfile(instance.profile);
        instance.isLoading = false;
        instance.isGenerating = "d-none";
        instance.$router.push({
          name: "Meal Plan"
        });
      } else {
        instance.isGenerating = "d-none";
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message: "Selecione um objetivo para continuar."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile.data.goal) {
        instance.goal = instance.profile.data.goal;
        if (instance.profile.data.goal === "loseWeight") {
          instance.loseWeight = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3"
          };
          instance.gainMuscles = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
          instance.stayHealthy = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
        } else if (instance.profile.data.goal === "gainMuscles") {
          instance.loseWeight = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
          instance.gainMuscles = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3"
          };
          instance.stayHealthy = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
        } else {
          instance.loseWeight = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
          instance.gainMuscles = {
            selected: false,
            class: "pseudo-button pt-3 pb-3 pl-3"
          };
          instance.stayHealthy = {
            selected: true,
            class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3"
          };
        }
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    var(--bg-color-blue),
    var(--bg-color-blue)
  ) !important;
}
.disclaimer {
  margin-bottom: -24px;
  padding-bottom: 6px;
}
</style>
